/*
 * palais-collection-filters.js
 *
 * Progressive enhancement for the collection filter dropdowns
 * (sections/collection-filters.liquid).
 *
 * The filtering itself is entirely server-side: every option inside a dropdown
 * is a real <a> linking to a Shopify storefront-filter URL, so picking a value
 * is a normal navigation that reloads the page already filtered. This script
 * ONLY improves the open/close UX of the native <details> dropdowns:
 *   - opening one dropdown closes the others (exclusive open)
 *   - clicking outside closes any open dropdown
 *   - Escape closes any open dropdown
 *
 * With JS disabled the <details> elements still open/close natively and every
 * filter link still works — nothing here is required for filtering.
 *
 * No dependencies. Loaded with `defer` by the section.
 */
(function () {
  var filters = Array.prototype.slice.call(
    document.querySelectorAll('[data-palais-filter]')
  );
  if (!filters.length) return;

  function closeAll(except) {
    filters.forEach(function (details) {
      if (details !== except) details.removeAttribute('open');
    });
  }

  filters.forEach(function (details) {
    // The native `toggle` event fires whenever this <details> opens or closes.
    // When it opens, collapse the others so only one panel shows at a time.
    details.addEventListener('toggle', function () {
      if (details.open) closeAll(details);
    });
  });

  // Click anywhere outside an open dropdown closes it.
  document.addEventListener('click', function (event) {
    var anyOpen = filters.some(function (details) {
      return details.open;
    });
    if (!anyOpen) return;
    if (!event.target.closest('[data-palais-filter]')) closeAll(null);
  });

  // Escape closes any open dropdown.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
